import styled from "styled-components";

const StyledUIStatusBadge = styled.div<{
  $status: "primary" | "secondary" | "success" | "error";
}>`
  background-color: ${(props): string =>
    props.$status === "primary"
      ? props.theme.colors.yellow
      : props.$status === "secondary"
        ? props.theme.colors.black
        : props.$status === "success"
          ? props.theme.colors.green
          : props.$status === "error"
            ? props.theme.colors.red
            : props.theme.colors.darkBg};
  border: ${(props): string =>
    props.$status === "primary"
      ? `1px solid ${props.theme.colors.yellow}`
      : props.$status === "secondary"
        ? `1px solid ${props.theme.colors.gray}`
        : props.$status === "success"
          ? `1px solid ${props.theme.colors.green}`
          : props.$status === "error"
            ? `1px solid ${props.theme.colors.red}`
            : `1px solid ${props.theme.colors.yellow}`};
  border-radius: 25px;
  padding: 5px;
  text-align: center;
  max-width: 120px;
  padding-left: 10px;
  padding-right: 10px;
  max-height: 28px;
  margin-right: 10px;
  color: ${(props): string =>
    props.$status === "primary"
      ? props.theme.colors.black
      : props.$status === "secondary"
        ? props.theme.colors.gray
        : props.$status === "success"
          ? props.theme.colors.darkBg
          : props.$status === "error"
            ? props.theme.colors.darkBg
            : props.theme.colors.yellow};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  text-transform: capitalize;
`;

export const UIStatusBadge = ({
  $status,
  text,
}: {
  $status: "primary" | "secondary" | "success" | "error";
  text?: string;
}): React.JSX.Element => {
  return (
    <StyledUIStatusBadge $status={$status}>
      {text || $status}
    </StyledUIStatusBadge>
  );
};
